import React from 'react';

import type { TaskStatus } from '../services/taskService';

import './TaskStatusSpinner.css';

export const TaskStatusSpinner: React.FC<{ status: TaskStatus; className?: string }> = ({
  status, className = '',
}) => {
  if (status !== 'ai_in_progress' && status !== 'human_in_progress') return null;

  return (
    <span className={`task-status-spinner ${className}`.trim()} role="img"
      aria-label={status === 'ai_in_progress' ? 'AI task running' : 'Human task running'} />
  );
};
